//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const EditorUserLevels = Object.freeze([3, 4, 8])

export default {
  name: 'CalendarPreviewBlock',
  props: {
    calendarItem: {
      type: Object,
      required: true
    },
    lines: {
      type: Number,
      default: 2
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    },
    editorUserLevels() {
      if (!this.account || !this.account.userLevels) return []
      return this.account.userLevels.filter((x) => EditorUserLevels.includes(x.levelId))
    }
  },
  methods: {
    onClick() {
      if (this.calendarItem.url) {
        window.open(this.calendarItem.url)
      }
    }
  }
}
